/** AUTO GENERATED FROM "node ./src/utils/build-icons.js". DO NOT TOUCH. * */
import React from 'react';
import classNames from 'classnames';

class Icon extends React.PureComponent {
  render() {
    const { className, svgRef, ...otherProps } = this.props;
    return (
      <svg
        width="82.46"
        height="82.55"
        viewBox="0 0 82.46 82.55"
        fill="currentColor"
        className={classNames('nmx-icon', className)}
        ref={svgRef}
        {...otherProps}>
        <path
          fill="#ffb81c"
          d="M20.21 20.26a1.25 1.25 0 0 1 1.73-.36l.45.31.93.64.68.49 1.12.8.81.59 1.28 1c2.81 2.11 5.89 4.53 9.16 7.25A263.14 263.14 0 0 1 68 62.16q7.6 8.91 14.24 18.42a1.254 1.254 0 1 1-2.06 1.43c-4.35-6.27-9.07-12.35-14.08-18.22a260 260 0 0 0-31.32-30.93l-.78-.62L32.56 31l-.72-.59-1.42-1.13c-1.4-1.12-2.76-2.17-4.06-3.15l-1.28-1-1.42-1-.75-.54-1-.73-1.35-.86a1.24 1.24 0 0 1-.37-1.71Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M35.63 31.2a1.25 1.25 0 0 1 .37 2.47h-.13l-20 2a1.25 1.25 0 0 1-.37-2.47h.13ZM50.51 44.23a1.25 1.25 0 0 1 .7 2.4h-.12l-25 6a1.25 1.25 0 0 1-.7-2.39h.12Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#ffb81c"
          d="M39.51 16.11a1.25 1.25 0 0 1 2.42.61v.14l-5 16a1.23 1.23 0 0 1-1.55.82 1.26 1.26 0 0 1-.86-1.44v-.12ZM52.51 29.22a1.25 1.25 0 0 1 2.48.33v.13l-3 16a1.252 1.252 0 0 1-2.48-.34v-.12Z"
          className="icon-fill icon-accent"/>
        <path
          fill="#fff"
          d="M1.24 0A1.25 1.25 0 0 0 0 1.11v5.18a164.7 164.7 0 0 0 2.51 24.06C5.43 46 10.41 58.56 18.07 66.22a34.044 34.044 0 1 0 48.15-48.14c-6.66-6.66-17-11.28-29.77-14.24l-1.46-.33c-2.45-.53-5-1-7.6-1.43A166.33 166.33 0 0 0 9.57.22c-1-.06-2-.1-3-.13L5.17 0Zm1.27 3.06V2.5h2.61l1.38.05h1.45l1.51.08A166.45 166.45 0 0 1 27 4.55c16.51 2.65 29.75 7.59 37.51 15.31A31.544 31.544 0 0 1 19.9 64.47c-7.23-7.23-12-19.32-14.8-34.56A160 160 0 0 1 2.51 3.06Z"
          className="icon-fill icon-base"/>
      </svg>

    );
  }
}

Icon.displayName = 'LeafIcon';

export default Icon;
